module.exports = __webpack_public_path__ + "img/close.d49c51a6.svg";